import { Property } from '@app/models/Property';
import { PropertyApi } from '@app/services/apiServices/PropertyApi';
import { NetworkErrorService } from '@app/services/NetworkError.service';
import { Homeowner } from '@app/models/Homeowner';
import { CountryCode } from '@app/models/CountryCode';
import { RegistrationStore } from '@app/pages/registration/stores/RegistrationStore';
import { CompleteRegistrationRequest } from '@app/models/CompleteRegistrationRequest';
import { RegistrationApi } from '@app/services/apiServices/RegistrationApi';
import { SpinnerService } from '@app/services/spinner.service';
import { MobileLoginService } from '@app/services/MobileLogin.service';
import { take } from "rxjs/operators";
import { PersonalInfoData } from "@app/components/personalInfo/personalInfo.directive";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";
import { TermsDialog } from "@app/pages/registration/terms.dialog";
import { SecurityQuestionsConfirmDialog } from "@app/pages/registration/securityQuestionsConfirm.dialog";
import { RegistrationStopHoldDialog } from "@app/pages/registration/registrationDialogStopHold.component";
import { RegistrationNoPropertyDialog } from "@app/pages/registration/registrationDialogNoProperty.component";
import { PasswordValidationData } from '@app/components/password/password.directive';
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";

@Component({
    selector: 'app-registration-easy',
    template: require('./registrationEasy.html')
})
export class RegistrationEasyComponent implements OnInit {

    @ViewChild('registrationForm', { static: true }) private registrationForm: NgForm;

    homeowner: Homeowner;
    property: Property;
    countryCode: CountryCode;
    viewedTc = false;
    optIn = true;
    invalidCheckVar: boolean = false;
    terms: string;
    password = { password: '' };

    emailAddressExists: boolean;
    isHoaHomeowner: boolean;
    accountActive: boolean;
    emailAddressError: boolean;
    isValidatingEmail: boolean;

    passwordsMatch: boolean;
    showPasswordInvalidMessage: boolean;
    passwordStrength: string;

    personalInfoData: PersonalInfoData;

    $stateParams: any;

    constructor(@Inject(WindowToken) private $window: Window,
                @Inject(AppDataService) private appDataService: AppDataService,
                @Inject(RegistrationStore) private registrationStore: RegistrationStore,
                @Inject(MatDialog) private dialog: MatDialog,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
                @Inject(PropertyApi) private propertyApi: PropertyApi,
                @Inject(RegistrationApi) private registrationApi: RegistrationApi,
                @Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(MobileLoginService) private mobileLoginService: MobileLoginService,
                @Inject(Router) private router: Router,
                @Inject(ActivatedRoute) private route: ActivatedRoute,
    ) {
        this.$stateParams = this.route.snapshot.queryParams;
    }

    ngOnInit() {
        this.homeowner = {
            id: null,
            version: null,
            firstName: this.$stateParams.first ? this.$stateParams.first : null,
            lastName: this.$stateParams.last ? this.$stateParams.last : null,
            contactInformation: {
                email: {
                    value: this.$stateParams.email ? this.$stateParams.email : null
                },
                phones: [
                    {
                        type: '',
                        countryCallingCode: 'USA',
                        value: this.$stateParams.phonenum ? this.$stateParams.phonenum : ''
                    }
                ],
                notifyBySms: false
            }
        };

        this.property = {
            couponId: this.$stateParams.propertyCouponId ? this.$stateParams.propertyCouponId : null,
            hoa: {
                couponId: this.$stateParams.associationCouponId ? this.$stateParams.associationCouponId : null,
                pmc: {
                    couponId: this.$stateParams.managementCouponId ? this.$stateParams.managementCouponId : null
                }
            },
            address: {}
        };

        this.personalInfoData = {
            homeowner: this.homeowner,
            emailAddressExists: this.emailAddressExists,
            isHoaHomeowner: this.isHoaHomeowner,
            useAnonymousApi: true,
            registration: true,
            accountActive: this.accountActive,
            emailAddressError: this.emailAddressError,
            isValidatingEmail: this.isValidatingEmail,
            registrationType: "easy"
        }
    }

    showTc() {
        let dialogRef = this.dialog.open(TermsDialog);
        dialogRef.afterClosed().pipe(take(1)).subscribe(value => {
            if (value === 'Y') {
                this.viewedTc = true;
            } else if (value === 'N') {
                this.viewedTc = false;
            }
        });
    }

    emailAddressValid(invalidObj) {
        for (let key in invalidObj) {
            if (invalidObj[ key ]) {
                this.invalidCheckVar = true;
                return;
            }
        }
        this.invalidCheckVar = false;
    }

    isPhoneNumberValid() {
        if (this.homeowner.contactInformation.phones && this.homeowner.contactInformation.phones.length > 0) {
            if (this.homeowner.contactInformation.phones[ 0 ].countryCallingCode === 'USA')
                return this.homeowner.contactInformation.phones[ 0 ].value.replace(/[^0-9]+/g, '').length === 10;
            else if (this.homeowner.contactInformation.phones[ 0 ].countryCallingCode !== 'USA')
                return this.homeowner.contactInformation.phones[ 0 ].value.replace(/[^0-9]+/g, '').length >= 7;
        }
        return false;
    }

    cancel() {
        this.registrationStore.clearAllData();
        this.$window.location.replace(this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL);
    }

    invalid() {
        return this.isPersonalInfoInvalid() || this.isPasswordInvalid() || !this.viewedTc;
    }

    isPersonalInfoInvalid() {
        this.homeowner = this.personalInfoData.homeowner;
        this.emailAddressExists = this.personalInfoData.emailAddressExists;
        this.accountActive = this.personalInfoData.accountActive;
        this.emailAddressError = this.personalInfoData.emailAddressError;
        this.isValidatingEmail = this.personalInfoData.isValidatingEmail;
        this.isHoaHomeowner = this.personalInfoData.isHoaHomeowner;

        return (this.emailAddressExists && this.isHoaHomeowner) ||
            this.invalidCheckVar ||
            !this.isPhoneNumberValid() ||
            !this.accountActive ||
            this.emailAddressError ||
            this.isValidatingEmail;
    }

    isPasswordInvalid() {
        // won't require password if user is already in auth provider
        if (this.emailAddressExists && !this.isHoaHomeowner)
            return false;
        else if (this.passwordsMatch &&
                !this.showPasswordInvalidMessage &&
                (this.passwordStrength === "Good" || this.passwordStrength === "Strong")) {
            return false;
        }
        return true;
    }

    submit() {
        this.spinnerService.showSpinner();
        let existing = this.emailAddressExists && !this.isHoaHomeowner;

        this.validateProperty().then(() => {
            let hoMarketingAgreement = {
                acceptedMarketing: this.optIn,
                acceptedMaketingDate: "",
                partyId: null
            }

            let registrationRequest = {
                emailAddress: this.homeowner.contactInformation.email.value,
                firstName: this.homeowner.firstName,
                lastName: this.homeowner.lastName,
                username: this.homeowner.contactInformation.email.value,
                password: this.password.password,
                homeownerId: this.homeowner.id,
                securityQuestionAnswers: null,
                existing: existing,
                phone: this.homeowner.contactInformation.phones[0].value
            }

            this.prepareHomeowner(registrationRequest);

            let completeRegistrationRequest: CompleteRegistrationRequest = {
                homeowner: this.homeowner,
                properties: [this.propertyApi.formatProperty(this.property)],
                amuiRegistrationRequest: registrationRequest,
                marketingAgreement: hoMarketingAgreement
            };

            this.registrationApi.completeRegisterUser(completeRegistrationRequest)
                .pipe(take(1)).subscribe({
                    next: () => {
                        this.spinnerService.closeSpinner();
                        this.registrationStore.clearAllData();
                        this.showRegistrationCompleteDialog();
                    },
                    error: error => {
                        this.spinnerService.closeSpinner();
                        if (error.error.errors && error.error.errors.length > 0) {
                            let errorMessage = '';
                            if (error.error.message) {
                                errorMessage = error.error.message;
                            }
                            error.error.errors.forEach(msg => {
                                errorMessage += '<br><br>' + msg;
                            })
                            this.errorHandlerService.handleNetworkError(error, true, errorMessage)
                                .pipe().subscribe(() =>  {
                                })
                        } else {
                            this.networkErrorService.handleNetworkError(error, true)
                                .pipe(take(1)).subscribe(resp => {
                                    if (resp === true) {
                                        this.submit();
                                    }
                                });
                        }
                    } });
        }, () => {
            this.spinnerService.closeSpinner();
        });
    }

    prepareHomeowner(registrationRequest) {
        this.homeowner.contactInformation.phones = [{
            ...this.homeowner.contactInformation.phones[0],
            type: "home",
        }]

        this.homeowner.contactInformation.mailingAddress = {
            line1: this.property.address.line1,
            line2: this.property.address.line2,
            unit: this.property.address.unit,
            postalCode: this.property.address.postalCode,
            state: this.property.address.state,
            city: this.property.address.city,
            country: this.property.address.country || "USA",
        }

        this.homeowner.contactInformation.amuiId = registrationRequest.username;
    }

    showRegistrationCompleteDialog() {
        let dialogRef = this.dialog.open(SecurityQuestionsConfirmDialog);

        dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
            // logout in the unlikely event of a previously logged-in user existing during a new or GP registration.
            this.$window.location.href = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL + "/registered/#/properties";
        });
    }

    validateProperty(): Promise<void>{
        return new Promise<void>((resolve, reject) => {
            this.propertyApi.propertiesValidateGet(true,
                this.property.hoa.pmc.couponId,
                this.property.hoa.couponId,
                this.property.couponId)
                .pipe(take(1))
                .subscribe({
                    next: resp => {
                        if (resp.valid === true && (resp.doNotProcess === false || resp.doNotProcessCode === "L01")) {
                            resolve();
                        } else {
                            if (resp.doNotProcessCode === "D01") {
                                this.dialog.open(RegistrationStopHoldDialog, {
                                    data: { reasonCode: resp.doNotProcessCode }
                                });
                            } else if (resp.doNotProcessCode === "M01") {
                                this.dialog.open(RegistrationStopHoldDialog, {
                                    data: { reasonCode: resp.doNotProcessCode }
                                });
                            } else { //No Matching record found.
                                this.dialog.open(RegistrationNoPropertyDialog, {
                                    data: { pmcId: this.property.hoa.pmc.couponId }
                                });
                            }
                            reject();
                        }
                    },
                    error: (err) => {
                        reject(err);
                    } });
        });
    }

    onPasswordValidation(passwordValidationData: PasswordValidationData) {
        this.passwordsMatch = passwordValidationData.passwordsMatch;
        this.showPasswordInvalidMessage = passwordValidationData.showPasswordInvalidMessage;
        this.passwordStrength = passwordValidationData.passwordStrength;
    }
}

